import Style from './style'

const DefaultInput = ({
	children,
	label,
	type,
	inputRef,
	placeholder,
	small,
	width,
	defaultValue,
}) => {
	return (
		<Style.Wrapper $small={small} $width={width}>
			{label && (
				<h2>
					{label}
					<span>*</span>
				</h2>
			)}

			<Style.InputDiv $small={small}>
				<input
					type={type || 'text'}
					ref={inputRef}
					placeholder={placeholder}
					defaultValue={defaultValue}
				/>
				<div>{children}</div>
			</Style.InputDiv>
		</Style.Wrapper>
	)
}

export default DefaultInput
